<div class="view-wrapper settings-view" @viewLoader>
  <div class="view-content bottom-space" #scrollRoot>
    <form [formGroup]="settingsForm" class="settings-form">
      <section id="visibility" class="view-section">
        <h4>{{ 'jobboard.platform.settings.visibility.headline' | transloco }}</h4>
        <app-platform-settings-visibility
          [form]="settingsForm"
          [saved]="savedSettings()"
        ></app-platform-settings-visibility>
      </section>

      <section id="notifications" class="view-section">
        <h4>{{ 'jobboard.platform.settings.notifications.headline' | transloco }}</h4>
        <app-platform-settings-notifications
          [form]="settingsForm"
          [recommendationsPaused]="settings.recommendationsPaused()"
        ></app-platform-settings-notifications>
      </section>
    </form>

    <section id="password" class="view-section">
      <h4>{{ 'jobboard.platform.settings.password.change-headline' | transloco }}</h4>
      <app-platform-settings-password></app-platform-settings-password>
    </section>

    <section id="tfa" class="view-section">
      <h4>{{ 'jobboard.platform.settings.tfa.headline' | transloco }}</h4>
      <app-platform-settings-tfa></app-platform-settings-tfa>
    </section>

    <section id="delete" class="view-section danger-zone">
      <h4>{{ 'jobboard.platform.settings.delete.headline' | transloco }}</h4>
      <app-platform-settings-delete></app-platform-settings-delete>
    </section>

    <ct-lib-form-saver
      [form]="settingsForm"
      [busy]="saving()"
      (onSave)="onSave()"
    ></ct-lib-form-saver>
  </div>
</div>
